module.exports = {"bewizr-agenda":{"empty":{"title":"无活动","detail":"您没有已安排的活动。"}}}